interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className=" text-primary-400 px-4 py-3 rounded-lg border border-primary-200">
        {message}
      </div>
    </div>
  );
}; 